var exports = {
  "VH": "ForwardMessagePreview.module__preview___NVNDMD",
  "Qs": "ForwardMessagePreview.module__content___NVNDMD",
  "iU": "ForwardMessagePreview.module__message___NVNDMD",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___NVNDMD",
  "oh": "ForwardMessagePreview.module__edited___NVNDMD",
  "kp": "ForwardMessagePreview.module__attachmentRow___NVNDMD",
  "$r": "ForwardMessagePreview.module__attachmentIcon___NVNDMD",
  "eI": "ForwardMessagePreview.module__attachmentSummary___NVNDMD",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___NVNDMD",
  "vH": "ForwardMessagePreview.module__thumbnailStack___NVNDMD",
  "xn": "ForwardMessagePreview.module__thumbnail___NVNDMD",
  "q_": "ForwardMessagePreview.module__thumbnailImage___NVNDMD",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___NVNDMD",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___NVNDMD",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___NVNDMD",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___NVNDMD",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___NVNDMD",
  "uZ": "ForwardMessagePreview.module__playIcon___NVNDMD",
  "mB": "ForwardMessagePreview.module__overflowCount___NVNDMD",
};

module.exports = exports;
